import bodymovin from 'lottie-web';

export const isMobile = {
	Android() {
		return navigator.userAgent.match(/Android/i);
	},
	BlackBerry() {
		return navigator.userAgent.match(/BlackBerry/i);
	},
	IOS() {
		return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	},
	Opera() {
		return navigator.userAgent.match(/Opera Mini/i);
	},
	Windows() {
		return navigator.userAgent.match(/IEMobile/i);
	},
	any() {
		return (
			isMobile.Android() ||
			isMobile.BlackBerry() ||
			isMobile.IOS() ||
			isMobile.Opera() ||
			isMobile.Windows()
		);
	},
};

export function preventAction(elem) {
	jQuery(elem).each(function () {
		jQuery(this).click(function (el) {
			el.stopPropagation();
			el.preventDefault();
		});
	});
}

export function calcMaxHeight(elem) {
	const arrHeight = [];

	jQuery(elem).each(function () {
		arrHeight.push($(this).first().outerHeight());
	});

	return Math.max(...arrHeight);
}

export function setEqualHeight(elem) {
	jQuery(elem).each(function () {
		jQuery(this).height(calcMaxHeight(elem));
	});
}

export function toggleBodyLock() {
	jQuery('body').toggleClass('lock');
}

export const animateCSS = (node, animation, prefix = 'animate__') => {
	return new Promise((resolve, reject) => {
		const animationName = `${prefix}${animation}`;

		node.classList.add(`${prefix}animated`, animationName);

		function handleAnimationEnd(event) {
			event.stopPropagation();
			node.classList.remove(`${prefix}animated`, animationName);
			resolve('Animation ended');
		}

		node.addEventListener('animationend', handleAnimationEnd, {
			once: true,
		});
	});
};
const animationCache = {};
const animationInstances = new WeakMap();

export function setAnimatedIcon(ajaxSuccess = false) {
	const animatedImages = document.querySelectorAll('.animation-container');

	animatedImages.forEach((el) => {
		if (animationInstances.has(el)) {
			return;
		}

		const staticImage = el.querySelector('.animation-image');
		const dynamicLinkImage = el.querySelector('.jet-listing-dynamic-link__icon');
		const animationIcon = el.querySelectorAll('svg');

		if (ajaxSuccess && animationIcon.length > 0) {
			return;
		}

		let animationClassName = null;
		if (staticImage) {
			animationClassName = [...staticImage.classList].find(className => className.startsWith('animation-image-'));
		} else if (dynamicLinkImage) {
			animationClassName = [...el.classList].find(className => className.startsWith('animation-image-'));
		}

		if (!animationClassName) {
			return;
		}

		const animationName = animationClassName.replace('animation-image-', '');
		const animationPath = AssetsPath.url + `/animations/${animationName}.json`;

		if (!animationCache[animationPath]) {
			animationCache[animationPath] = fetch(animationPath).then(res => res.json());
		}

		animationCache[animationPath].then(animationData => {
			const animationItem = bodymovin.loadAnimation({
				container: el,
				renderer: 'svg',
				loop: false,
				autoplay: false,
				animationData: animationData,
			});

			animationInstances.set(el, animationItem);

			if (staticImage) {
				staticImage.classList.add('hidden');
			} else if (dynamicLinkImage) {
				dynamicLinkImage.classList.add('hidden');
			}

			el.addEventListener('mouseenter', () => {
				animationItem.goToAndStop(0, true);
				animationItem.play();
			});

			el.addEventListener('complete', () => {
				animationItem.goToAndStop(0, true);
			});
		});
	});
}


export function sleep(ms) {
	return new Promise((resolve) => setTimeout(resolve, ms));
}

export const vis = (function () {
	let stateKey,
		eventKey,
		keys = {
			hidden: 'visibilitychange',
			webkitHidden: 'webkitvisibilitychange',
			mozHidden: 'mozvisibilitychange',
			msHidden: 'msvisibilitychange',
		};
	for (stateKey in keys) {
		if (stateKey in document) {
			eventKey = keys[stateKey];
			break;
		}
	}
	return function (c) {
		if (c) document.addEventListener(eventKey, c);
		return !document[stateKey];
	};
})();

export function setSameHeight(selector) {
	const elements = document.querySelectorAll(selector);
	if (!elements.length) {
		return;
	}

	const elementsArray = Array.from(elements);

	elementsArray.forEach((element) => {
		element.style['min-height'] = '';
	});

	let maxHeight = elements[0].offsetHeight;
	elementsArray.forEach((element) => {
		if (maxHeight < element.offsetHeight) {
			maxHeight = element.offsetHeight;
		}
	});

	elementsArray.forEach((element) => {
		element.style['min-height'] = `${maxHeight}px`;
	});
}

export function adjustTextAlignment() {
	const elements = [
		...document.querySelectorAll('.tapestry_card__title h5'),
		...document.querySelectorAll('.popup-tapestry__name'),
	];


	elements.forEach(function (title) {
		if (/[א-ת]/.test(title.textContent)) {
			title.style.textAlign = 'right';
		} else {
			title.style.textAlign = 'left';
		}
	});
}

document.addEventListener('DOMContentLoaded', () => {
	// Set up a MutationObserver to watch for changes in the DOM
	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (mutation.type === 'childList') {
				// Run the alignment function when new cards are added
				adjustTextAlignment();
			}
		});
	});

    // Observe the container where tapestry cards are added
	const tapestryContainer = document.querySelector('.tapestry-grid');

	if (tapestryContainer) {
		observer.observe(tapestryContainer, { childList: true, subtree: true });
	}
	adjustTextAlignment();
});

$(document).on('ajaxSuccess',function(event, xhr, settings) {
	if (settings.url.indexOf('jsf_ajax') !== -1 && settings.data && settings.data.includes('action=jet_smart_filters')) {
		setTimeout(function(){
			setAnimatedIcon(true);
		},100);
	}
})

export function isRtl(){
	const html = document.documentElement;
	const lang = html.lang || '';
	if (lang.startsWith('he')){
		return true
	}

	return false;
}

export function toggleSliderNextButton($slider, disable) {
    if (disable) {
        $('.slick-next', $slider).addClass('slick-disabled');
    } else {
        $('.slick-next', $slider).removeClass('slick-disabled');
    }
}

export function areAllSlidesVisible(firstSlideRect, lastSlideRect, wrapperRect) {
    const firstLeftEdge = firstSlideRect.x;
    const lastRightEdge = lastSlideRect.x + lastSlideRect.width;
    const wrapperLeftEdge = wrapperRect.x;
    const wrapperRightEdge = wrapperRect.x + wrapperRect.width;
    
    return firstLeftEdge >= wrapperLeftEdge && lastRightEdge <= wrapperRightEdge;
}

export function isLastSlideVisibleRtl(lastSlideRect, wrapperRect) {
    return lastSlideRect.x >= wrapperRect.x;
}

export function isLastSlideVisibleLtr(lastSlideRect, wrapperRect) {
    return (lastSlideRect.x + lastSlideRect.width) <= (wrapperRect.x + wrapperRect.width);
}

$(document).on('ajaxSuccess',function(event, xhr, settings) {
	if (settings.url.indexOf('jsf_ajax') !== -1 && settings.data && settings.data.includes('action=jet_smart_filters')) {
		setTimeout(function(){
			setAnimatedIcon(true);
		},100);
	}
})
